import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import CropImage from '../../../shared/form/cropImage/cropButton';

const useStyles = makeStyles(() => ({
  cabecalho: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: '40px',
  },
  formularioTitulo: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    fontWeight: 'bold',
    color: '#5e6784',
    textTransform: 'uppercase',
  },
  avatar: {
    width: 88,
    height: 88,
    border: 'solid 1.8px #dfdfe6',
  },
  imagemReplaceFoto: {
    width: 88,
    height: 88,
    backgroundColor: '#30b0ff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 30,
    fontWeight: 600,
    fontFamily: 'IBM Plex Sans',
    borderRadius: 44,
    marginBottom: 30,
  },
}));

const CabecalhoCadastro = (props) => {
  const { form } = props;
  const classes = useStyles();

  return (
    <div className={classes.cabecalho}>
      <p className={classes.formularioTitulo}>Concluir Cadastro</p>
      {form.avatar ? <Avatar alt="Avatar" src={form.avatar} className={classes.avatar} />
        : (
          <div
            className={classes.imagemReplaceFoto}
          >
            {form.nome ? form.nome.substring(0, 2).toUpperCase() : 'US'}
          </div>
        )}
      <CropImage />

    </div>
  )
};

export default CabecalhoCadastro;
